import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const body1StrongClassNames = {
  root: 'fui-Body1Strong'
};
/**
 * Styles for the root slot
 */
export const useBody1StrongStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fkhj508",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "f1i3iumi"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fkhj508{font-size:var(--fontSizeBase300);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1i3iumi{line-height:var(--lineHeightBase300);}"]
});